/**
 *  author: Patrick Vyn Badiang
 *
 *  Description:
 *  is the main page, contains everything
 *  we want to be shown on the first page
 */

import Section from "./Section";
import Hero from "./Hero";
import BoardPreview from "./BoardPreview";
import NewsletterSection from "./NewsletterSection";
import GalleryPreview from "./GalleryPreview";

import Updates from "../../../utils/Updates";

//Section Texts
import SummaryOfFasa from "../../../utils/SummaryOfFasa";


const MainPage = (props) => {
  //Section Titles
  const events = "Upcoming Events";

  return (
    <>
      <Hero />

      {/* what is fasa */}
      <SummaryOfFasa />

      {/* upcoming events */}
      <Section text={events} />
      <Updates />

      {/* meet the board */}
      <BoardPreview />

      {/* newsletter signup */}
      <NewsletterSection />

      {/* gallery preview */}
      <GalleryPreview />
    </>
  );
};

export default MainPage;
